import React, {
  useMemo,
  useReducer,
  type FC,
  type PropsWithChildren,
} from 'react'
import { MultiBuyDispatcher, dispatcherContext, stateContext } from './Context'
import { Status } from '../../components/Status'
import { createSetErrorAction } from './Actions'
import { reducer } from './Reducer'

type Props = {
  enabled: boolean
}

export const MultiBuyProvider: FC<PropsWithChildren<Props>> = ({
  enabled,
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    enabled,
    error: false,
    errorMessage: undefined,
  })

  const actions = useMemo<MultiBuyDispatcher>(
    () => ({
      setError: createSetErrorAction(dispatch),
    }),
    [],
  )

  const contextValue = useMemo(
    () => ({
      ...state,
      enabled,
    }),
    [state, enabled],
  )

  return (
    <dispatcherContext.Provider value={actions}>
      <stateContext.Provider value={contextValue}>
        <Status
          error={{
            status: state.error,
            message: state.errorMessage,
            onDismiss: () =>
              actions.setError({ error: false, errorMessage: undefined }),
          }}
        />
        {children}
      </stateContext.Provider>
    </dispatcherContext.Provider>
  )
}
